var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('administration-offers-layout',{attrs:{"title":"Список целевых действий","error-text":"Список целевых действий не загружен","api-method":_vm.getEmployeesTargetActions}})
}
var staticRenderFns = []

export { render, staticRenderFns }